module.exports = __webpack_public_path__ + "1791188489487/images/africa.7bf519d.png";